import { skipToken } from '@reduxjs/toolkit/query';
import { Conversation } from 'lib-shared-types-api/src/conversations';
import { useCallback, useMemo } from 'react';

import { templatesApi } from 'apis/templates';
import { useCopilotTrial } from 'utils/useCopilotTrial';

interface UsePreloadRecommendedQuickRepliesProps {
  conversation?: Conversation;
  channel?: string;
  outboundMessages: number;
  locale?: string;
  conversationId?: string;
}

export const usePreloadRecommendedQuickReplies = ({
  conversation,
  channel,
  outboundMessages,
  locale,
  conversationId,
}: UsePreloadRecommendedQuickRepliesProps): void => {
  const { hasCopilot } = useCopilotTrial();

  const findAutoReplyMessages = useCallback((conversation) => {
    const events = conversation?.events ?? [];
    const messages = events.filter((event) => {
      return (
        event?.type === 'conversation:message_added' &&
        event?.is_auto_reply === 'true'
      );
    });
    return messages.length;
  }, []);

  const firstReply = useMemo(() => {
    const autoReplyMessages = findAutoReplyMessages(conversation);
    return !!(outboundMessages - autoReplyMessages);
  }, [outboundMessages, conversation, findAutoReplyMessages]);

  const emailRelatedChannels = channel === 'email' || channel === 'contactform';

  const preloadRecommendations =
    emailRelatedChannels && hasCopilot && conversationId && !firstReply;

  templatesApi.useReadRecommendationsQuery(
    preloadRecommendations
      ? {
          csid: conversationId?.toString() || '',
          locale: locale ?? 'en',
        }
      : skipToken,
  );
};
